/**
 * Hosts configured in images.remotePatterns (next.config.mjs).
 * KEEP IN SYNC with next.config.mjs — the config cannot import runtime utils.
 *
 * Config answers "what the optimizer MAY fetch";
 * this answers "should THIS url go through the optimizer".
 *
 * Precondition: expects the output of normalizeImageUrl()
 * (absolute http(s) or site-relative paths).
 *
 * Garbage / non-URL strings are treated as optimizable (status quo):
 * next/image fails, GameCard onError shows the fallback. That costs one
 * optimizer round-trip; keeping them raw would change behavior.
 */
const OPTIMIZED_IMAGE_HOSTS = new Set(["cdn.hub88.io", "files.onetouch.io"]);

export function isOptimizableImageUrl(url: string): boolean {
  const candidate = url.toLowerCase();

  if (!candidate.startsWith("http://") && !candidate.startsWith("https://")) {
    return true;
  }

  try {
    if (!candidate.startsWith("https://")) {
      return false;
    }

    return OPTIMIZED_IMAGE_HOSTS.has(new URL(candidate).hostname);
  } catch {
    return false;
  }
}
